/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

const KPICard = ({
  title,
  count,
  change,
  isPositive,
  icon: Icon,
  color,
  bgClass,
}) => (
  <div
    className={`${bgClass || "bg-slate-900 border-slate-800"} p-4 sm:p-6 rounded-2xl sm:rounded-3xl border shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow`}
  >
    <div className="absolute top-0 right-0 p-2 sm:p-4 opacity-10 group-hover:opacity-20 transition-opacity text-white">
      <Icon size={48} className="sm:w-16 sm:h-16" />
    </div>
    <div className="relative z-10">
      <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-xl sm:rounded-2xl flex items-center justify-center mb-2 sm:mb-3 bg-white/10 text-white">
        <Icon size={18} className="sm:w-5 sm:h-5" />
      </div>
      <p className="text-white/70 font-medium text-xs sm:text-sm">{title}</p>
      <h3 className="text-2xl sm:text-3xl font-bold text-white mt-1 mb-2">
        {count}
      </h3>
      <div className="flex items-center gap-1 sm:gap-2">
        <span
          className={`flex items-center gap-1 text-xs font-bold px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-full ${
            isPositive
              ? "bg-emerald-500/20 text-emerald-300 border border-emerald-500/30"
              : "bg-red-500/20 text-red-300 border border-red-500/30"
          }`}
        >
          {isPositive ? (
            <TrendingUp size={10} className="sm:w-3 sm:h-3" />
          ) : (
            <TrendingDown size={10} className="sm:w-3 sm:h-3" />
          )}
          {change > 0 ? `+${change}%` : `${change}%`}
        </span>
        <span className="text-xs text-white/60">vs last period</span>
      </div>
    </div>
  </div>
);

export default KPICard;
